/* eslint-disable @typescript-eslint/no-explicit-any */

import { useNode } from "@craftjs/core";
import { Accordion, AccordionDetails, AccordionSummary, Grid, Typography } from "@mui/material";
import { ReactNode } from "react";

interface SettingsSectionProps {
    title: string;
    summary?: (props: Array<string>) => ReactNode;
    props?: Array<string>;
    children: ReactNode;
}

const SettingsSection = ({ title, props, summary, children }: SettingsSectionProps) => {
    const { nodeProps } = useNode((node) => ({
        nodeProps:
            props &&
            props.reduce((res: any, key: any) => {
                res[key] = node.data.props[key] || null;

                return res;
            }, {}),
    }));

    return (
        <Accordion
            elevation={0}
            square
            sx={{
                background: "transparent",
                boxShadow: "none",
                "&:before": {
                    backgroundColor: "rgba(0, 0, 0, 0.05)",
                },
                "&.Mui-expanded": {
                    margin: 0,
                    minHeight: 40,
                    "&:before": {
                        opacity: 1,
                    },
                },
                "& .MuiAccordionSummary-content": {
                    alignItems: "center",
                    margin: 0,
                },
                "& .MuiAccordionDetails-root": {
                    display: "block",
                },
            }}
        >
            <AccordionSummary>
                <Typography variant="caption" sx={{ flexShrink: 0, mr: 2 }}>
                    {title}
                </Typography>
                <Typography variant="caption" sx={{ ml: "auto", color: "text.secondary" }}>
                    {summary &&
                        summary(
                            props &&
                                props.reduce((acc: any, key: any) => {
                                    acc[key] = nodeProps[key];
                                    return acc;
                                }, {})
                        )}
                </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ m: (theme) => theme.spacing(0, 1) }}>
                <Grid container spacing={2}>
                    {children}
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};

export default SettingsSection;
